import { downloadDesign } from 'features/challenges/slice';
import { selectCurrentUser } from 'features/auth/slice';
import { useDispatch, useSelector } from 'react-redux';

import { Card, Heading } from '@frontendmentorio/design-system-v2';

import DownloadDesignButton, {
  renderDesignConfirmation,
} from 'features/challenges/DownloadDesignButton';
import DownloadStarterButton from 'features/challenges/DownloadStarterButton';

export default function Downloads({ challenge }) {
  const dispatch = useDispatch();

  const currentUser = useSelector(selectCurrentUser);

  const handleClick = () => {
    dispatch(downloadDesign({ id: challenge.id }));
  };

  return (
    <div
      className="flex flex-col gap-5 tablet:flex-row"
      data-testid="downloads"
    >
      <Card className="flex flex-col gap-4 p-5">
        <Heading level="5" tagName="h2">
          Download starter files
        </Heading>

        <p>
          {challenge.type === 'free'
            ? 'Includes assets, JPG images of the design files, and a basic style guide. There’s also a README to help you get started.'
            : 'Includes assets and everything you need to build the project. There’s also a README to help you get started.'}
        </p>

        <DownloadStarterButton challenge={challenge} />
      </Card>

      <Card className="flex flex-col gap-4 p-5">
        <Heading level="5" tagName="h2">
          Download design file
        </Heading>

        <p>
          All of our designs are available as Figma files. Using the design file
          will help you build more accurate solutions.
        </p>

        <DownloadDesignButton
          challenge={challenge}
          modal={renderDesignConfirmation(currentUser, challenge)}
          onClick={handleClick}
        />
      </Card>
    </div>
  );
}
